import {VehiclePhotoResponseBody} from '@dms/api/shared';

import {Nullish} from 'shared/web';

// Structural subset so photo shapes from other API surfaces (e.g. TEAS vehicles) qualify too.
export function getVehicleCoverPhoto<T extends Pick<VehiclePhotoResponseBody, 'isCoverPhoto'>>(
  photos?: T[] | Nullish
): T | null {
  return photos?.find((photo) => photo.isCoverPhoto) ?? null;
}
